import { ActivityRuleViolation } from 'farmdok-rest-api';

export default class ActivityRuleViolationService {
  private readonly activityRuleViolations: ActivityRuleViolation[];

  private readonly activityRuleViolationsMap = new Map<string, ActivityRuleViolation[]>();

  constructor(activityRuleViolations: ActivityRuleViolation[]) {
    this.activityRuleViolations = activityRuleViolations;

    // eslint-disable-next-line no-restricted-syntax
    for (const violation of activityRuleViolations) {
      // eslint-disable-next-line no-continue
      if (!violation.activityId) continue;

      const existingViolations = this.activityRuleViolationsMap.get(violation.activityId) ?? [];
      existingViolations.push(violation);
      this.activityRuleViolationsMap.set(violation.activityId, existingViolations);
    }
  }

  public getActivityRuleViolations(activityId?: string): ActivityRuleViolation[] {
    if (!activityId) return this.activityRuleViolations;
    return this.activityRuleViolationsMap.get(activityId) ?? [];
  }
}
